import { gql, useQuery } from '@zenbusiness/application-commons-graphql';
import { useError } from '@zenbusiness/application-commons-logging';

export const MFA_METHODS_QUERY = gql`
  query MfaMethodsQuery {
    mfaMethods {
      requireMfa
      methods {
        id
        type
        confirmed
        isRecoveryMethod
        phoneNumber
        name
        createdAt
        lastAuth
      }
    }
  }
`;

export function useMfaMethods() {
  const { data, loading, error, refetch } = useQuery(MFA_METHODS_QUERY, {
    noThrow: true,
  });

  useError(error);

  return {
    methods: data?.mfaMethods?.methods || [],
    requireMfa: data?.mfaMethods?.requireMfa || false,
    error,
    loading,
    refetch,
  };
}
